import styles from "../styles.module.css";

type Props = {
  title: string;
  step?: number;
  min?: number | string;
  max?: string;
  value?: any;
  customValidity?: string;
  setter?: Function;
  showAsterisk?: boolean;
  required?: boolean;
};

const CampoDate = ({
  title,
  min,
  max,
  value,
  customValidity,
  setter,
  showAsterisk,
  required,
}: Props) => {
  const nome = title.toLowerCase().replace(" ", "_");

  return (
    <div className={styles.campo}>
      <label htmlFor={nome} className={styles.title}>
        {title}
        <span className={styles.required}>{showAsterisk && "*"}</span>:
      </label>

      <input
        type="date"
        name={nome}
        required={required}
        min={min}
        className={setter ? "" : styles.borderNone}
        disabled={setter ? false : true}
        max={max}
        value={value}
        onInvalid={(e) => {
          if (customValidity) {
            e.currentTarget.setCustomValidity(customValidity);
          }
        }}
        onChange={(e) => {
          if (setter) {
            const v = e.target.value;
            setter(v);
            e.currentTarget.setCustomValidity("");
          }
        }}
      />
    </div>
  );
};

export default CampoDate;
